import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ETPListItem } from '@zero/crypto/domain';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { EtpListItemComponent } from '../etp-list-item/etp-list-item.component';

@Component({
  selector: 'crypto-etp-list',
  templateUrl: './etplist.component.html',
  styleUrls: ['./etplist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EtpListItemComponent, TranslocoPipe, ModalComponent],
})
export class ETPListComponent {
  @Input() public items: ETPListItem[];

  public readonly commonRoutes = commonRoutes;

  constructor(private _modalService: NgbModal) {}

  public showStakingRewardModal = (modalContent: TemplateRef<HTMLElement>): void => {
    this._modalService.open(modalContent);
  };
}
